module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-source-wordpress/gatsby-browser.js'),
      options: {"plugins":[],"url":"https://ccfamilyroofing.kinsta.cloud/graphql","schema":{"timeout":100000,"requestConcurrency":5,"queryDepth":15,"circularQueryLimit":5,"typePrefix":"Wp","perPage":100,"previewRequestConcurrency":5},"type":{"GfForm":{"exclude":true},"GfFormConnection":{"exclude":true},"GfFormEdge":{"exclude":true},"GfEntry":{"exclude":true},"GfEntryConnection":{"exclude":true},"GfEntryEdge":{"exclude":true},"GfSubmittedEntry":{"exclude":true},"GfSubmittedEntryConnection":{"exclude":true},"GfSubmittedEntryEdge":{"exclude":true},"GfDraftEntry":{"exclude":true},"GfDraftEntryConnection":{"exclude":true},"GfDraftEntryEdge":{"exclude":true},"GfFieldError":{"exclude":true},"RootQuery":"{ excludeFieldNames: ['viewer', 'node', 'schemaMd5'], },"},"verbose":true,"catchLinks":true},
    },{
      plugin: require('../node_modules/gatsby-plugin-facebook-pixel/gatsby-browser.js'),
      options: {"plugins":[],"pixelId":"493255199600715"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
